import { render } from "./VehicleEntryEditPage.vue?vue&type=template&id=a48d1f58"
import script from "./VehicleEntryEditPage.vue?vue&type=script&lang=js"
export * from "./VehicleEntryEditPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__